import React from 'react';
import { X } from '@phosphor-icons/react';

export type PreContractFinalizeConfirmMetrics = {
    systemSize: string;
    production: string;
    multiplier: string;
    annualUsage: string;
    losses: string;
};

type PreContractFinalizeConfirmModalProps = {
    open: boolean;
    metrics: PreContractFinalizeConfirmMetrics;
    onContinue: () => void;
    onCancel: () => void;
};

export const PreContractFinalizeConfirmModal: React.FC<
    PreContractFinalizeConfirmModalProps
> = ({ open, metrics, onContinue, onCancel }) => {
    if (!open) return null;

    const rows = [
        { label: 'System size', value: metrics.systemSize },
        { label: 'Production', value: metrics.production },
        { label: 'Multiplier', value: metrics.multiplier },
        { label: 'Annual usage', value: metrics.annualUsage },
        { label: 'Losses', value: metrics.losses },
    ];

    return (
        <div
            className="pci-finalize-popup pci-finalize-confirm"
            role="dialog"
            aria-modal="true"
            aria-labelledby="pci-finalize-confirm-title"
        >
            <button
                type="button"
                className="pci-finalize-popup__backdrop"
                onClick={onCancel}
                aria-label="Cancel finalize"
            />
            <div className="pci-finalize-popup__dialog pci-finalize-confirm__dialog">
                <header className="pci-finalize-popup__head">
                    <h2 id="pci-finalize-confirm-title">Confirm design</h2>
                    <button
                        type="button"
                        className="pci-finalize-popup__close"
                        onClick={onCancel}
                        aria-label="Cancel"
                    >
                        <X size={18} weight="bold" />
                    </button>
                </header>
                <div className="pci-finalize-popup__body">
                    <p className="pci-finalize-popup__lead">
                        Review the selected design details, then continue to save.
                    </p>
                    <section
                        className="pci-solar-layout-details__group pci-solar-layout-details__group--system"
                        aria-label="System design"
                    >
                        <header className="pci-solar-layout-details__group-head">
                            <h4 className="pci-solar-layout-details__group-title">System design</h4>
                        </header>
                        <dl className="pci-solar-layout-details__metrics pci-solar-layout-details__metrics--system">
                            {rows.map((row) => (
                                <div key={row.label} className="pci-solar-layout-details__metric">
                                    <dt>{row.label}</dt>
                                    <dd>{row.value}</dd>
                                </div>
                            ))}
                        </dl>
                    </section>
                    <div className="pci-finalize-popup__actions">
                        <button type="button" className="pci-btn pci-btn--secondary" onClick={onCancel}>
                            Cancel
                        </button>
                        <button type="button" className="pci-btn pci-btn--primary" onClick={onContinue}>
                            Continue
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PreContractFinalizeConfirmModal;
